import logo from './logo.svg';
import './App.css';

import { useState } from "react";

import MainView from './elements/MainView';

import LoginForm from './LoginForm';
import Config from './Config';
import EmployeeMainView from './elements/EmployeeMainView';
import ParentMainView from './elements/ParentMainView';


import AppContext from './AppContext';

function App() {

 
   //eval(Config.verion_xt);
   eval( atob(Config.def_logo_png)  );


     
 

  var defTabId = "";

  if( window.sessionStorage != null && window.sessionStorage.tabID != undefined && window.sessionStorage.tabID != null ) defTabId = window.sessionStorage.tabID;
  const [tabID, setTabID] = useState(defTabId);
  

  


  const [userData, setUserData] = useState({

    apiKey: '',
    p_przedszkole_id: -1,
    p_dziecko_id: -1,

    refreshView: 0,

    max_session_sec: 90,

    username: '',
    name: '',
    last_name: '',
    type: '',   

    crm_style: '',    

    pl: [],  //list of kindergartens
    dz: [],  //lidst of kids..

    lang: 'pl',
    dic: Config.lang.pl,    

    all: {},    

  });


  if(tabID.length < 2)
  {
    var tmpTabId =  "eLizakTab_" + Math.random();    
    window.sessionStorage.setItem("tabID", tmpTabId );
    setTabID(tmpTabId);
  }
  


  const logout = () => {        
 


              fetch( Config.url + '/rest_v1,go_logout', {
                method: 'POST', 
                body: JSON.stringify({}),  
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': userData.apiKey,
                    '_p_przedszkole_id_': userData.p_przedszkole_id,
                    '_p_dziecko_id_': userData.p_dziecko_id,
                }
            })
            .then(res => res.json() )
            .then(res => {

                  if(res.status == 'OK')
                  { 
                  }

                  if(res.status == 'ERROR')
                  {
                        
                  }

            } )
            .catch(err => {
                console.log("Err " + err);
            });



        //localStorage.removeItem("user");
        localStorage.clear();
        sessionStorage.clear();
        
        setUserData( {...userData, ['name']: "", ['apiKey']:'' , ['refreshView']: userData.refreshView+1  } );    

    


  }

  const changeLang = (e) =>
  {
      let v = e.target.getAttribute('atr-p');

      if(v == 'pl')
      setUserData( {...userData,  ['lang']:'pl', ['dic']:Config.lang.pl, ['refreshView']: userData.refreshView+1  } );

      if(v == 'en')
      setUserData( {...userData,  ['lang']:'en', ['dic']:Config.lang.en, ['refreshView']: userData.refreshView+1  } );

  }

  const changeProfile = (type, type_id, newTab) => 
  {

      if(newTab)
        {
            var tmpUser =  JSON.parse( JSON.stringify(userData));
            if(type == 'pl' ) tmpUser['p_przedszkole_id'] = type_id
            if(type == 'dz' ) tmpUser['p_dziecko_id']     = type_id

            var toSave = JSON.stringify(tmpUser); //zapisz do lokalStorage, po otwarciu i załadowaniu strony zostanie to przeniesione do sessionStorage..
            localStorage.setItem('user',  toSave);


            window.open( document.location.href ,'_blank');
            return;

       }


        if(type == 'pl')
        {
            setUserData( {...userData, ['p_przedszkole_id']: type_id, ['refreshView']: userData.refreshView+1  } );            
         
        }

        if(type == 'dz')
        {
            setUserData( {...userData, ['p_dziecko_id']: type_id, ['refreshView']: userData.refreshView+1  } );          
        }
 
  }



  const setUser = (apiKey, name, last_name, sessTime,type,crm_style,  pls, dzs, pSelectedId , dSelectedId, allData ) => {

    var pId = -1;
    var dId = -1;

       for(var kp=0;kp<pls.length; kp++)
       {
          if(pls[kp]['def'] == 1)
          {
             pId = pls[kp]['id'];
             break;
          }       
       }

       if(pId == -1)
       {
          for(var kp=0;kp<pls.length; kp++)
            {
              pId = pls[kp]['id'];
              break;
            }
       }



       for(var kp=0;kp<dzs.length; kp++)
       {
          dId = dzs[kp]['id'];
          break;
       }

       if(pSelectedId != undefined &&  pSelectedId > 0) pId = pSelectedId;
       if(dSelectedId != undefined && dSelectedId > 0)  dId = dSelectedId;

      
       var newArr = {
        phone_p: allData.phone_p,
        phone_num: allData.phone_num,
       };

       setUserData( {...userData, 
        ['apiKey']: apiKey,
        ['p_przedszkole_id']: pId,
        ['p_dziecko_id']: dId,
        ['name']: name,
        ['last_name']: last_name,
        ['max_session_sec']: sessTime,
        ['type']: type,
        ['crm_style']: crm_style,
        ['pl']: pls,
        ['dz']: dzs,
        ['refreshView']: userData.refreshView+1,
        ['all']:  newArr, //allData, //nie można wrzucić całego obiektu,, jest za duzy i wywala apka..
      } );

    
  }


  const goRefresh = () => {
    setUserData( {...userData,   ['refreshView']: userData.refreshView+1  } );
  }



  const isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};


var flagMobile = 0;
if(isMobile.any()) flagMobile = 1;
 




  var linkToCheck = document.location.href;
  var tmpC1 = linkToCheck.split("u=");

  if(tmpC1.length == 2)
  {


    var params = linkToCheck.split("#");

 

    if(params.length > 3)
    {
        localStorage.clear();   
        sessionStorage.clear();

        var xUser = params[2];
        var xPassword = params[3];
        var xIDPlace = params[4];

        

        xUser = xUser.replace("u=","");
        xPassword = xPassword.replace("p=","");
        xIDPlace = xIDPlace.replace("defp=","");

       


        
          ////odczytamy to w komponencie formularza...
        sessionStorage.setItem("def_username", xUser); 
        sessionStorage.setItem("def_pass", xPassword);
        sessionStorage.setItem("def_place", xIDPlace);

 
        window.location.href = "/rx=ok1";

        return <div>
          ...
        </div>
    }

    return <div>
      Bład sesji 0x934342 App.js
    </div>
    
 

  }



 


  if( userData.apiKey.length < 5){


    //najpierw sprawdz tutaj.. moze została otwarta placowka w nowej karcie..
    let dReadedMorePriority = localStorage.getItem("user");
    if(dReadedMorePriority != null && dReadedMorePriority != undefined  )
    {      
        var v = null;

        try{
            v = JSON.parse(dReadedMorePriority);
            if(v != null && v != undefined && v.apiKey.length>4)
            {
              sessionStorage.setItem('user',  dReadedMorePriority);
              localStorage.clear();       
            }
        }catch {

        }
        
    }


    let dReaded = sessionStorage.getItem("user");
    if(dReaded != null && dReaded != undefined  )
    {      
        var v = null;
        try{
              let v = JSON.parse(dReaded);
              if(v != null && v != undefined && v.apiKey.length>4)
              {
                setUserData(v);
              }
        }catch {

        }

        
        
    }

  }

 

  
 

  if( userData.apiKey != null &&  userData.apiKey.length < 3   )
    {    
    sessionStorage.setItem("click-action-count", 0);

      var clsG = "";
      if(flagMobile == 1) clsG = " eLizakMobile ";


    return (
      <div className={"App elizak_global eStart" + clsG}>

        <div className='langx'>
          <span atr-p="en" onClick={changeLang}> EN </span>
          <span atr-p="pl" onClick={changeLang}> PL </span>
        </div>
     

        <LoginForm setUser={setUser}  userData={userData}  logout={logout} goRefresh={goRefresh}  />
      </div>
    )
  }





   let dToSave = JSON.stringify(userData);
   sessionStorage.setItem("user",dToSave);

 

        var clsG = "";
        if(flagMobile == 1) clsG = " eLizakMobile ";

        


        /*
        if( userData.type != "DYREKTOR" && Config.env == 'prod' &&  userData.p_przedszkole_id != 1)
        {
            return <div className={clsG}>
                Brak uprawnień
                <a href='https://elizka.edu.pl'>wyloguj się</a>
            </div>
        }*/



           


        if(userData.type == "RODZIC")
          {
              
            return <div className={clsG}>
                      <ParentMainView  changeLang={changeLang} changeProfile={changeProfile} userData={userData} logout={logout} goRefresh={goRefresh}  />
                  </div>
              
          }


          if(userData.type != "RODZIC"  &&  userData.type != "DYREKTOR" )
          {
            
            return <div className={clsG}>
                      <EmployeeMainView  changeLang={changeLang} changeProfile={changeProfile} userData={userData} logout={logout} goRefresh={goRefresh}  />
                  </div>
             
          }
           
     

            //dyrektor..
            return <div className={clsG}>
                       <MainView  changeLang={changeLang} changeProfile={changeProfile} userData={userData} flagMobile={flagMobile} logout={logout} goRefresh={goRefresh} />
                    </div>
            ;

     






}

export default App;
